export default {"src":"/_next/static/media/compensation-powered-by.2f9a00da.svg","height":45,"width":345,"blurWidth":0,"blurHeight":0};